import { motion } from "framer-motion";
import { EASE } from "./Reveal";

// Region dots (approx lat/long → SVG coords in 1000x500 equirectangular)
const REGIONS = [
  { name: "North America", cx: 235, cy: 200, offices: ["Houston", "Boston", "Vancouver", "Denver"] },
  { name: "Europe", cx: 505, cy: 175, offices: ["London", "Munich", "Paris", "Stockholm"] },
  { name: "Asia", cx: 740, cy: 245, offices: ["Tokyo", "Seoul", "Bengaluru", "Singapore"] },
];

// Very simplified continent outlines
const CONTINENTS = "M170,140 C210,120 260,130 300,150 L340,200 L320,260 L270,290 L220,300 L180,270 L150,220 Z M420,110 C460,100 520,110 560,130 L590,180 L560,220 L510,220 L470,200 L440,170 Z M600,150 C650,140 720,150 780,170 L830,220 L820,290 L760,300 L700,290 L650,260 L620,220 Z M330,320 C370,310 410,330 420,370 L390,420 L350,410 L330,370 Z M580,320 C610,310 640,330 640,370 L610,410 L580,400 L570,360 Z M760,340 C790,335 810,360 800,390 L775,410 L755,395 L750,370 Z";

export default function WorldMap() {
  return (
    <div className="relative w-full" data-testid="world-map">
      <svg viewBox="0 0 1000 500" className="w-full h-auto" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
            <path d="M 20 0 L 0 0 0 20" fill="none" stroke="#E2E8F0" strokeWidth="0.5" />
          </pattern>
        </defs>
        <rect width="1000" height="500" fill="url(#grid)" />

        {/* Continents */}
        <motion.path
          d={CONTINENTS}
          fill="#F1F5F9"
          stroke="#0A2540"
          strokeWidth="0.8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, ease: EASE }}
        />

        {/* Latitude lines */}
        {[100, 200, 300, 400].map((y) => (
          <line key={y} x1="0" x2="1000" y1={y} y2={y} stroke="#E2E8F0" strokeWidth="0.5" strokeDasharray="2 4" />
        ))}

        {/* Connections */}
        <motion.path
          d="M235,200 Q370,120 505,175 Q620,120 740,245"
          fill="none"
          stroke="#C9A961"
          strokeWidth="1"
          strokeDasharray="4 4"
          initial={{ pathLength: 0 }}
          whileInView={{ pathLength: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 2, ease: EASE, delay: 0.4 }}
        />

        {/* Region markers */}
        {REGIONS.map((r, i) => (
          <motion.g
            key={r.name}
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, ease: EASE, delay: 0.6 + i * 0.15 }}
          >
            <circle cx={r.cx} cy={r.cy} r="14" fill="#C9A961" opacity="0.15" />
            <circle cx={r.cx} cy={r.cy} r="6" fill="#C9A961" opacity="0.35" />
            <circle cx={r.cx} cy={r.cy} r="3" fill="#0A2540" />
            <text
              x={r.cx + 14}
              y={r.cy - 12}
              className="font-mono"
              fontSize="12"
              fill="#0A2540"
              fontFamily="JetBrains Mono, monospace"
            >
              {r.name.toUpperCase()}
            </text>
            <text
              x={r.cx + 14}
              y={r.cy + 4}
              fontSize="10"
              fill="#64748B"
              fontFamily="JetBrains Mono, monospace"
            >
              {r.offices.join(" · ")}
            </text>
          </motion.g>
        ))}
      </svg>
    </div>
  );
}
